export const model = {
    id: null,
    hospitalizationService: [],
    physiotherapyIndeces:[],
    created_at: '',
    updated_at: ''
};
